import MovieContainer from './MovieContainer';

export default MovieContainer;
